import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Check, Download, Infinity, RefreshCw } from 'lucide-react';
const modules = [{
  num: '01',
  title: 'Fundamentos',
  desc: 'Las bases teóricas y técnicas de la electricidad domiciliaria.',
  bullets: ['Teoría eléctrica esencial', 'Componentes y materiales', 'Lectura de planos básicos']
}, {
  num: '02',
  title: 'Montaje',
  desc: 'El montaje real de instalaciones eléctricas paso a paso.',
  bullets: ['Cableado y canalización', 'Tableros y protecciones', 'Conexiones seguras']
}, {
  num: '03',
  title: 'Instalación',
  desc: 'Instalaciones domiciliarias aplicadas a viviendas reales.',
  bullets: ['Proyectos residenciales completos', 'Aplicación de normativa', 'Casos reales en viviendas']
}];
export function Modules() {
  return <section id="programa" className="py-24 bg-ed-black relative border-t border-white/5" data-id="element-324">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-325">
        <div className="text-center mb-20" data-id="element-326">
          <span className="text-ed-green font-bold tracking-widest uppercase text-sm mb-3 block" data-id="element-327">
            El programa completo
          </span>
          <h2 className="text-4xl sm:text-5xl font-black uppercase tracking-tight text-white" data-id="element-328">
            Tres módulos. <br className="sm:hidden" data-id="element-329" />
            Una formación integral.
          </h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 mb-16" data-id="element-330">
          {modules.map((mod, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: i * 0.2
        }} className="bg-ed-dark border border-zinc-800 rounded-2xl p-8 relative group hover:border-ed-green/40 transition-all hover:glow-green-sm flex flex-col" data-id="element-331">
              {/* Large Number Background */}
              <div className="absolute top-4 right-6 text-8xl font-black text-transparent" style={{
            WebkitTextStroke: '2px rgba(255,255,255,0.03)'
          }} data-id="element-332">
                {mod.num}
              </div>

              {/* 3D Book Mockup Mini */}
              <div className="w-32 h-40 mx-auto mb-8 relative perspective-1000" data-id="element-333">
                <div className="w-full h-full relative preserve-3d transform rotate-y-[-15deg] group-hover:rotate-y-0 transition-transform duration-500" data-id="element-334">
                  <div className="absolute inset-0 bg-gradient-to-br from-zinc-800 to-ed-black rounded-r-md border border-zinc-700 shadow-xl overflow-hidden" data-id="element-335">
                    {mod.num === '01' || mod.num === '02' || mod.num === '03' ? <>
                        <img src={mod.num === '01' ? 'https://cdn.magicpatterns.com/uploads/a1FEocdNHNBvyXakAamyW8/PORTADA_MODULO_1web.png' : mod.num === '02' ? 'https://cdn.magicpatterns.com/uploads/ajR14EnHkjR7pf88KeU62q/1_PORTADA_MODULO_2_web.png' : 'https://cdn.magicpatterns.com/uploads/q3pKPAZcWK2HzZkGKnSH6t/PORTADA_MODULO_3_web.png'} alt={`Manual Módulo ${mod.num} — ${mod.title}`} className="absolute inset-0 w-full h-full object-cover object-top" data-id="element-336" />
                        <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-transparent opacity-30 pointer-events-none" data-id="element-337"></div>
                      </> : <>
                        <div className="absolute left-0 top-0 bottom-0 w-2 bg-ed-green border-r border-black/20" data-id="element-338"></div>
                        <div className="p-3 pt-6 flex flex-col h-full" data-id="element-339">
                          <span className="text-ed-green font-black text-sm opacity-80" data-id="element-340">
                            M{mod.num}
                          </span>
                          <h4 className="text-white font-black text-lg uppercase leading-tight mt-1" data-id="element-341">
                            {mod.title}
                          </h4>
                        </div>
                      </>}
                  </div>
                  <div className="absolute top-1 bottom-1 -right-1 w-1 bg-zinc-300 rounded-r-sm transform translate-z-[-1px]" data-id="element-342"></div>
                </div>
              </div>

              <div className="relative z-10 flex-grow" data-id="element-343">
                <h3 className="text-2xl font-black text-white uppercase mb-3" data-id="element-344">
                  {mod.title}
                </h3>
                <p className="text-zinc-400 mb-6 min-h-[48px]" data-id="element-345">{mod.desc}</p>

                <ul className="space-y-3" data-id="element-346">
                  {mod.bullets.map((bullet, j) => <li key={j} className="flex items-start gap-2" data-id="element-347">
                      <Check className="w-5 h-5 text-ed-green shrink-0" data-id="element-348" />
                      <span className="text-sm text-zinc-300 font-medium" data-id="element-349">
                        {bullet}
                      </span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>

        {/* Bottom Features */}
        <div className="flex flex-wrap justify-center gap-6 sm:gap-12 text-zinc-400" data-id="element-350">
          <div className="flex items-center gap-2" data-id="element-351">
            <Infinity className="w-5 h-5 text-ed-green" data-id="element-352" />
            <span className="text-sm font-semibold uppercase tracking-wider" data-id="element-353">
              Acceso de por vida
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-354">
            <Download className="w-5 h-5 text-ed-green" data-id="element-355" />
            <span className="text-sm font-semibold uppercase tracking-wider" data-id="element-356">
              Material descargable
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-357">
            <RefreshCw className="w-5 h-5 text-ed-green" data-id="element-358" />
            <span className="text-sm font-semibold uppercase tracking-wider" data-id="element-359">
              Actualizaciones incluidas
            </span>
          </div>
        </div>
      </div>
    </section>;
}